import { render, staticRenderFns } from "./CreateTransportation.vue?vue&type=template&id=28919a32"
import script from "./CreateTransportation.vue?vue&type=script&lang=js"
export * from "./CreateTransportation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports